<script lang="ts" setup>
import { onMounted, ref, watch, useTemplateRef } from 'vue';
import { useElementVisibility } from '@vueuse/core';

interface AppLazyLoadEmits {
  (eventName: 'inner-element-visible'): void;
}

const emit = defineEmits<AppLazyLoadEmits>();

const innerComponentContainer = useTemplateRef('innerComponentContainer');

const isInnerComponentVisible = useElementVisibility(innerComponentContainer, {
  once: true,
});

const shouldRenderInnerComponent = ref(isInnerComponentVisible.value);

onMounted(() => {
  if (isInnerComponentVisible.value) {
    return;
  }

  watch(
    isInnerComponentVisible,
    () => {
      shouldRenderInnerComponent.value = true;
      emit('inner-element-visible');
    },
    { once: true }
  );
});
</script>

<template>
  <div ref="innerComponentContainer" class="app-lazy-load-component">
    <slot v-if="shouldRenderInnerComponent" />
  </div>
</template>

<style scoped lang="scss">
.app-lazy-load-component {
  width: 100%;
  height: 100%;
}
</style>
